import React, { useState } from "react";
import { message } from "antd";

function Contact() {
  const [contactDetails, setContactDetails] = useState({});
  const handleForm = (e) => {
    e.preventDefault();
    if (contactDetails.name && contactDetails.email && contactDetails.phone && contactDetails.message) {
      message.loading("Please Wait", [1], () => {
        message.success("Your message has been submitted");
        setContactDetails({ name: "", email: "", message: "", phone: "" });
      });
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactDetails({ ...contactDetails, [name]: value });
  };
  return (
    <>
      <div className="container mt-5">
        <div className="row">
          <div className="col-lg-7 p-3 col-md-7  col-xs-12">
            <form onSubmit={handleForm}>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label for="inputName">Name</label>
                  <input
                    name="name"
                    type="text"
                    value={contactDetails?.name}
                    className="form-control"
                    id="inputName"
                    placeholder="Enter Name"
                    required
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group col-md-6 col-sm-12">
                  <label for="inputEmail">Email</label>
                  <input
                    name="email"
                    type="email"
                    value={contactDetails?.email}
                    className="form-control"
                    id="inputEmail"
                    placeholder="Enter Email"
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <label for="inputPhone">Phone</label>
                <input
                  name="phone"
                  type="text"
                  className="form-control"
                  value={contactDetails?.phone}
                  id="inputPhone"
                  placeholder="Enter Phone No."
                  required
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label for="inputMessage">Message</label>
                <textarea
                  value={contactDetails?.message}
                  name="message"
                  className="form-control"
                  id="inputMessage"
                  rows="3"
                  required
                  onChange={handleInputChange}
                />
              </div>

              <button type="submit" className="btn btn-dark btn-large">
                Submit
              </button>
            </form>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 p-3">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d19861.860623540484!2d-0.075053!3d51.518122!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xed8d72a929219d66!2sInfuse%20Consulting!5e0!3m2!1sen!2sus!4v1615787036675!5m2!1sen!2sus"
              allowfullscreen=""
              loading="lazy"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Contact;
